import _ from "lodash";
import chatModule from "./type";

const actions = {
    [chatModule.actions.toggleSwipe](store, payload) {
        store.commit(chatModule.mutations.toggleSwipe, payload)
    },
    async [chatModule.actions.conversations.loadGroup](store, { group, limit, page }) {
        let response = await axios.get('/api/getConversations', { params: { group, page, limit }})
        if (response.status === 200) {
            let data = response.data
            if (data[group] && _.toArray(data[group]).length) {
                store.dispatch(chatModule.actions.conversations.push, {
                    conversations: _.toArray(data[group]),
                    group
                })
            }
            return _.toArray(data[group]).length
        }
    },
    [chatModule.actions.conversations.clearGroup](store, payload){
        store.commit(chatModule.mutations.conversations.clearGroup, payload)
        store.commit(chatModule.mutations.conversations.afterUpdate)
    },
    [chatModule.actions.conversations.push](store, payload){
        store.commit(chatModule.mutations.conversations.push, payload)
        store.commit(chatModule.mutations.conversations.afterUpdate)
    },
    [chatModule.actions.conversations.pushUnblockedConversations](store, payload) {
        store.commit(chatModule.mutations.conversations.pushUnblockedConversations, payload)
        store.commit(chatModule.mutations.conversations.afterUpdate);
    },
    [chatModule.actions.conversations.unshift](store, payload){
        store.commit(chatModule.mutations.conversations.unshift, payload)
        store.commit(chatModule.mutations.conversations.afterUpdate)
    },

    [chatModule.actions.conversations.update](store, payload){
        store.commit(chatModule.mutations.conversations.update, payload)
        store.commit(chatModule.mutations.conversations.afterUpdate)
    },
    [chatModule.actions.conversations.updateConversationEvent](store, payload){
        store.commit(chatModule.mutations.conversations.updateConversationEvent, payload)
        store.commit(chatModule.mutations.conversations.afterUpdate)
    },
    [chatModule.actions.conversations.markAsRead](store, { userId, eventId, chatType, sync }){
        store.commit(chatModule.mutations.conversations.markAsRead, { userId, eventId, chatType })
        store.commit(chatModule.mutations.conversations.afterUpdate)

        if (sync) {
            if (!!userId && !eventId) {
                axios.post(`/api/markConversationAsRead/${userId}`);
            } else if (!!userId && !!eventId) {
                axios.post(`/api/markEventConversationAsRead/${eventId}/${userId}`)
            }
        }
    },
    [chatModule.actions.conversations.remove](store, payload){
        store.commit(chatModule.mutations.conversations.remove, payload)
        store.commit(chatModule.mutations.conversations.afterUpdate)
    },
    [chatModule.actions.conversations.removeAllUserBlockedChats](store, payload) {
        store.commit(chatModule.mutations.conversations.removeAllUserBlockedChats, payload)
        store.commit(chatModule.mutations.conversations.afterUpdate)
    },
    [chatModule.actions.sendTypeEvent](store, payload) {
        let key = payload.userId + (payload.eventId ? '_' + payload.eventId : '');
        let lastTypeEventDate = store.getters[chatModule.getters.lastTypeEvent](key);
        if(!lastTypeEventDate ||
            (moment(new Date(),'YYYY-MM-DD HH:mm:ss')).diff(lastTypeEventDate, 'seconds') > 5){
            store.commit(chatModule.mutations.setLastTypeEventTime, key)
            let response = axios.post(`/api/sendTypeEvent`,payload)
            if (response.status === 200) {

            }
        }
    },
    // add emoji to message
    async [chatModule.actions.messages.addEmoji](store, payload) {
        let response = await axios.post('/api/messages/addEmoji', {  message_id:payload.msg.id,emoji: payload.emoji })
        if (response.status === 200) {
           store.commit(chatModule.mutations.message.addEmoji, {
               msg: payload.msg,
               emoji: payload.emoji,
               emoji_code: store.getters.emojiCode(payload.emoji),
               msg_index : payload.msg_index,
               conversation_key : payload.conversation_key,
               user_from : auth.getUserId()
            })
        }
    },
    // add emoji to message
    async [chatModule.actions.messages.deleteEmoji](store, payload) {
        let response = await axios.post('/api/messages/deleteEmoji', { message_id:payload.msg.id })
        if (response.status === 200) {
            store.commit(chatModule.mutations.message.deleteEmoji, {
                msg: payload.msg,
                msg_index : payload.msg_index,
                conversation_key : payload.conversation_key,
                user_from : auth.getUserId()
            })
        }
    },
    // loadMessages
    async [chatModule.actions.messages.load](store, payload) {
        let userId = payload.userId
        let limit = 70;
        let conversationId = payload.conversationId;
        let messages = []
        let cursor = store.getters[chatModule.getters.conversations.cursor](conversationId)

        if(cursor === 'complete'){
          return [];
        }
        let loadingUrls = store.getters[chatModule.getters.conversations.loadingChats]

        const messageUrl = `/api/getConversationMessages/${conversationId}`;
        const findIndex = _.indexOf(loadingUrls, messageUrl)

        if (findIndex !== -1) {
            return [];
        } else {
            store.commit(chatModule.mutations.conversations.addLoadingChat, {
                url: messageUrl
            })
        }

        try {
            let response = await axios.get(`/api/getConversationMessages/${conversationId}?limit=${limit}&after=${cursor}`)
            if (response.status === 200) {

                store.commit(chatModule.mutations.conversations.setCursor, {
                  after: response.data.next_cursor,
                  conversationId: conversationId
                })

                store.commit(chatModule.mutations.conversations.removeLoadingChat, {
                    url: messageUrl
                })

                let data = response.data
                messages = _.toArray(data.data);

                store.commit(chatModule.mutations.messages.unshift, {
                    messages: messages.reverse(),
                    userId
                })

            }
        } catch (error) {
            console.error(error)
        }

        return messages
    },
    // loadEventMessages
    async [chatModule.actions.messages.loadEvent](store, payload) {
        let eventId = payload.eventId
        let userId = payload.userId
        let limit = 70;
        let conversationId = payload.conversationId;
        let chatHistoryId = `${payload.eventId}-${payload.userId}`
        let messages = []
        let loadingUrls = store.getters[chatModule.getters.conversations.loadingChats]

        let cursor = store.getters[chatModule.getters.conversations.cursor](conversationId)
        if(cursor === 'complete'){
          return [];
        }
        const messageUrl = `/api/getConversationMessages/${conversationId}`;
        const findIndex = _.indexOf(loadingUrls, messageUrl)

        if (findIndex !== -1) {
            return [];
        } else {
            store.commit(chatModule.mutations.conversations.addLoadingChat, {
                url: messageUrl
            })
        }

        try {
            let response = await axios.get(`/api/getConversationMessages/${conversationId}?limit=${limit}&after=${cursor}`)
            if (response.status === 200) {
                store.commit(chatModule.mutations.conversations.removeLoadingChat, {
                    url: messageUrl
                })

                store.commit(chatModule.mutations.conversations.setCursor, {
                  after: response.data.next_cursor,
                  conversationId: conversationId
                })

                let data = response.data
                messages = _.toArray(data.data)

                store.commit(chatModule.mutations.messages.unshift, {
                  messages: messages.reverse(),
                    eventId,
                    userId
                })

            }
        } catch (error) {
            console.error(error)
        }

        return messages
    },
    async [chatModule.actions.messages.loadGroup](store, payload) {
        let eventId = payload.eventId
        let chatHistoryId = payload.eventId
        let limit = 70;
        let conversationId = payload.conversation_id;
        let messages = []
        let loadingUrls = store.getters[chatModule.getters.conversations.loadingChats]

        let cursor = store.getters[chatModule.getters.conversations.cursor](conversationId)
        if(cursor === 'complete'){
          return [];
        }
        const messageUrl = `/api/getConversationMessages/${conversationId}`;
        const findIndex = _.indexOf(loadingUrls, messageUrl)

        if (findIndex !== -1) {
            return [];
        } else {
            store.commit(chatModule.mutations.conversations.addLoadingChat, {
                url: messageUrl
            })
        }

        try {
            let response = await axios.get(`/api/getConversationMessages/${conversationId}?limit=${limit}&after=${cursor}`)
            if (response.status === 200) {
                store.commit(chatModule.mutations.conversations.removeLoadingChat, {
                    url: messageUrl
                })

                store.commit(chatModule.mutations.conversations.setCursor, {
                  after: response.data.next_cursor,
                  conversationId: conversationId
                })

                let data = response.data
                messages = _.toArray(data.data)
                store.commit(chatModule.mutations.messages.unshift, {
                    messages : messages.reverse(),
                    eventId : eventId
                })

            }
        } catch (error) {
            console.error(error)
        }

        return messages
    },
    // tryDeleteChatMessage
    [chatModule.actions.messages.delete](store, {userId, eventId, messageId}) {
        let my_club = false;
        if(parseInt(eventId) > 0){
            my_club = store.getters.getMyClub(eventId);
        }
        if (store.rootState.userIsPro || my_club) {
            axios.post('/api/markMessageAsRemoved', { messageId })
                .then((response) => {
                    if (response.status === 200) {
                        let data = response.data
                        store.commit(chatModule.mutations.message.update, {
                            userId,
                            eventId,
                            message: data.message
                        })
                        store.dispatch(chatModule.actions.conversations.update, {
                            tracker: 'markMessageAsRemoved',
                            userId,
                            eventId,
                            message: data.message,
                            isNewUnreadMessage: false,
                            insertIfMissing: false
                        })
                    }
                })
        } else {
            store.dispatch('requirementsAlertShow', 'deletemsg')
        }
    },
}

export default actions
